import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  delay,
  filter,
  map,
  Observable,
  tap
} from 'rxjs';

const UTM_HEADERS = 'utm_headers';

@Injectable({
  providedIn: 'root'
})
export class AffiliateService {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  public utmParams = signal<Params | null>(
    localStorage.getItem(UTM_HEADERS)
      ? JSON.parse(localStorage.getItem(UTM_HEADERS) as string)
      : null
  );

  checkQueryParams(): Observable<Params | null> {
    return this.route.queryParams.pipe(
      delay(0), // кейс редиректа /m /r
      map((query) => getGGBandHeaders(query)),
      filter((headers) => !!headers),
      tap((headers) => {
        this.utmParams.set(headers);
        localStorage.setItem(UTM_HEADERS, JSON.stringify(headers));
        this.router.navigate([], {
          relativeTo: this.route
        });
      })
    );
  }

  clear(): void {
    this.utmParams.set(null);
    localStorage.removeItem(UTM_HEADERS);
  }
}

function getGGBandHeaders(query: Params): Params | null {
  if (
    query['utm_campaign'] &&
    query['utm_content'] &&
    query['utm_medium'] &&
    query['utm_source'] &&
    query['utm_project'] &&
    query['click_id']
  ) {
    return {
      'X-ClickId': query['click_id'],
      'X-UtmCampaign': query['utm_campaign'],
      'X-UtmContent': query['utm_content'],
      'X-UtmSource': query['utm_source'],
      'X-UtmProject': query['utm_project'],
      'X-UtmMedium': query['utm_medium']
    };
  }

  return null;
}
